require('../../node_modules/select2/dist/js/select2.full');
require('../../node_modules/select2/dist/css/select2.css');

jQuery(document).ready(function($){
    $('select').select2();
});